import styled from 'styled-components'

const TabWrapper = styled.div`
  height: 3.125rem;
  overflow: hidden;
  display: flex;
  align-items: stretch;
  justify-content: flex-start;
`

export default TabWrapper
